<template>
  <v-dialog
    v-model="dialogIsShown"
    max-width="500px"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        x-small
      >
        Mentions légales
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="white--text secondary pa-4">
        Mentions légales
      </v-card-title>

      <v-card-text
        v-html="description"
        style="max-height: 300px;"
        class="pa-4"
      ></v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="dialogIsShown = false"
        >
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LegalNoticeDialog',

  props: {
    value: Boolean,
  },

  data: () => ({
    description: `
      <p>
        Votre candidature, lorsqu'elle est recevable, est versée dans notre
        <b>réserve de recrutement</b>
        prioritaire pour l'année académique 2021-2022 et ce, en application du Décret du 24
        juillet 1997 fixant le statut des membres du personnel directeur et enseignant et du
        personnel auxiliaire d'éducation des Hautes Ecoles organisées ou subventionnées par la
        Communauté française ou du Décret du 20 juin 2008 relatif aux membres du personnel
        administratif des Hautes Ecoles.
      </p>
      <p>
        Conformément au règlement du Parlement européen et du Conseil du 27 avril 2016 relatif à la
        protection des personnes physiques à l'égard du traitement des 
        <b>données à caractère personnel</b>
        et à la libre circulation de ces données, toutes les informations recueillies à l'occasion
        de votre postulation sont enregistrées et conservées, d'une part, pour les besoins de votre
        dossier de candidature et, d'autre part, pour la constitution de votre dossier dans le cas
        d'un engagement futur. Seules les personnes habilitées auront accès à vos données. Elles ne
        seront pas transférées à des tiers et seront conservées pendant un délai de 5 ans. Le
        traitement de ces données est sécurisé.
      </p>
      <p>
        Vous pouvez, à tout moment, accéder aux informations vous concernant, les rectifier ou les
        supprimer en vous adressant à Madame Jennifer DEMOL à l'adresse e-mail suivante:
        <a href="mailto:jennifer.demol@hainaut.be">jennifer.demol@hainaut.be</a>.
      </p>
    `,
  }),

  computed: {
    dialogIsShown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
